import CountdownTimer from '@pixelunion/pxs-countdown-timer';
import ProductList from '../components/ProductList';

export default class DynamicCountdown {
  constructor(section) {
    this.el = section.el;
    new CountdownTimer(this.el);

    if (section.data.productId) {
      this.productList = new ProductList({ el: this.el, id: `shopify-section-${section.id}` });
    }
  }

  onSectionUnload() {
    if (this.productList) {
      this.productList.unload();
    }
  }
}
